export const normalizeRoomMode = source => {
    if (!source) return null;
    const maxPlayers = Number(source.maxPlayers);
    const layoutMode = String(source.layoutMode || '').trim().toLowerCase();

    if (maxPlayers === 2 || layoutMode === 'two-player') return 2;
    if (maxPlayers === 3 || layoutMode === 'three-player') return 3;
    if (maxPlayers >= 4 || layoutMode === 'standard' || layoutMode === 'four-player') return 4;
    return null;
};

export const readStoredRoomMode = roomId => {
    if (typeof window === 'undefined') return null;
    try {
        const activeRaw = window.localStorage.getItem('ludoActiveSession');
        const active = activeRaw ? JSON.parse(activeRaw) : null;
        if (active && (!roomId || active.roomId === roomId)) {
            return normalizeRoomMode(active);
        }
    } catch (_) {}
    return null;
};
